import clsx from "clsx";
import type { HTMLAttributes } from "react";
import React from "react";

const variants = ["primary", "secondary", "outline"] as const;
const palettes = ["neutral", "green", "orange", "red", "blue"] as const;

const variantClasses: Record<(typeof palettes)[number], Record<(typeof variants)[number], string>> = {
	neutral: {
		primary: clsx("bg-Surface-neutral text-Text-action-primary"),
		secondary: clsx("bg-Surface-action-neutral text-Text-primary"),
		outline: clsx("border-Border-primary-light border-1"),
	},
	green: {
		primary: clsx("bg-green-800 text-Text-action-primary"),
		secondary: clsx("bg-green-200 text-Text-primary"),
		outline: clsx("border-green-200 border-1 text-Text-primary"),
	},
	orange: {
		primary: clsx("bg-warning-800 text-Text-action-primary"),
		secondary: clsx("bg-orange-200 text-Text-primary"),
		outline: clsx("border-orange-200 border-1 text-Text-primary"),
	},
	red: {
		primary: clsx(""),
		secondary: clsx("bg-red-200 text-Text-primary"),
		outline: clsx(""),
	},
	blue: {
		primary: clsx("bg-info-800 text-Text-action-primary"),
		secondary: clsx("bg-sky-200 text-Text-primary"),
		outline: clsx("border-sky-200 border-1 text-Text-primary"),
	},
};

export interface TagProps extends HTMLAttributes<HTMLDivElement> {
	variant?: (typeof variants)[number];
	palette?: (typeof palettes)[number];
	iconLeft?: React.ReactNode;
	iconRight?: React.ReactNode;
}

export function Tag({ variant = "primary", palette = "neutral", className, children, iconLeft, iconRight, ...props }: TagProps) {
	return (
		<div
			className={clsx(
				"inline-flex gap-2xs transition-colors duration-200 justify-center items-center px-xs py-2xs rounded-[6px] font-medium w-fit",
				variantClasses[palette][variant],
				className,
			)}
			{...props}
		>
			{iconLeft}
			{children ?? ""}
			{iconRight}
		</div>
	);
}
